import { render, staticRenderFns } from "./Komissiyasi.vue?vue&type=template&id=475335a2&"
import script from "./Komissiyasi.vue?vue&type=script&lang=js&"
export * from "./Komissiyasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports